import { render, staticRenderFns } from "./Karmameter.vue?vue&type=template&id=113db6a7&scoped=true&"
import script from "./Karmameter.vue?vue&type=script&lang=js&"
export * from "./Karmameter.vue?vue&type=script&lang=js&"
import style0 from "./Karmameter.vue?vue&type=style&index=0&id=113db6a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113db6a7",
  null
  
)

export default component.exports